function SpinningText({ text, children }) {
  const lenght = text.length;
  const deg = 360 / lenght;

  return (
    <div className="containSipin">
      <div className="spinning-text-wrapper">
        <div className="spinning-text">
          <p>
            {text.split("").map((letra, i) => (
              <span
                key={i}
                style={{
                  transform: `rotate(${deg * i}deg)`,
                }}
              >
                {letra}
              </span>
            ))}
          </p>
        </div>
        {children}
      </div>
    </div>
  );
}

export default SpinningText;
